module.exports = __webpack_public_path__ + "img/home-bg2.81ef9d62.png";